import React from 'react'
import "../styles/1.css"
function Companydet() {
  return (
    <div className='co'>
        <hr style={{width:"100%",color:"white"}} />
    <div className='rights'>
        <p style={{fontSize:"12px"}}>All the Rights are Reserved @2026-Dev by WebAstic</p>
      </div>
      
    </div>
  )
}

export default Companydet
